'use client';

import { useState, FormEvent } from 'react';

export interface ContactFormSubmission {
  name: string;
  email: string;
  orderNumber?: string;
  message: string;
}

export default function ContactForm({
  subject,
  intentLabel,
  showOrderNumber,
  onDone,
}: {
  subject: string;
  intentLabel: string;
  showOrderNumber: boolean;
  onDone: (payload: ContactFormSubmission) => void;
}) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    // Frontend-only. Replace with `fetch('/api/contact', ...)` when backend is added.
    await new Promise((r) => setTimeout(r, 500));
    setSubmitting(false);
    onDone({
      name,
      email,
      ...(showOrderNumber && orderNumber ? { orderNumber } : {}),
      message,
    });
  }

  return (
    <div className="contact-card">
      <div className="contact-subject-chip">
        <span className="contact-subject-label">Subject:</span>
        <span className="contact-subject-value">{subject}</span>
        <span className="contact-subject-sep" aria-hidden>·</span>
        <span className="contact-subject-intent">{intentLabel}</span>
      </div>

      <h2 className="contact-form-title">Send us a message</h2>
      <p className="contact-form-sub">
        Fill in the form and a member of the team will get back to you.
      </p>

      <form onSubmit={onSubmit} noValidate>
        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            className="contact-input"
            type="text"
            autoComplete="name"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            className="contact-input"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {showOrderNumber && (
          <div className="contact-field">
            <label className="contact-label" htmlFor="contact-order">Order number <span className="contact-optional">(optional)</span></label>
            <input
              id="contact-order"
              className="contact-input"
              type="text"
              placeholder="#1234"
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
            />
          </div>
        )}
        <div className="contact-field">
          <label className="contact-label" htmlFor="contact-message">Message</label>
          <textarea
            id="contact-message"
            className="contact-input contact-textarea"
            required
            rows={5}
            maxLength={2000}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <span className="contact-counter">{message.length} / 2000</span>
        </div>
        <button type="submit" className="contact-button" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send message'}
        </button>
      </form>
    </div>
  );
}
